<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';
import CommonService from '@/services/common';

import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../../components/generic/GenericDataTable.vue';
import GenericCustomAutocompleteV2 from '../../../components/generic/GenericCustomAutocompleteV2.vue';
import GenericBooleanDropdown from '../../../components/generic/GenericBooleanDropdown.vue';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    GenericDataTable,
    ResponsiveButton,
    GenericCustomAutocompleteV2,
    GenericBooleanDropdown
  },
  data(){
    return {
        filters: {
            monthStartDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
            idPlanningTrueUpProductsWeightedAverageValue: null
        },
        filtersImport:{
            monthStartDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            endingInventoryDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
            poolName: null,
            isFinal: false
        },
        showImportDialog:false,
        optionCombo: [],
        productsWeightedAverageValue: [],
        selectedItem: null,

        weeklyData: {
            totalQuantity: null,
            weightedAverageDensity: null,
            weightedAveragePremiumOrDiscount: null
        }
    }
  },
  validations(){
    return {
        
    }
  },
  watch:{
    'filters.monthStartDate'(){
        this.loadProductsWeightedAverageValue();
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configurationHeader = config.getConfiguration('ProductsWeightedAverageValue');
    this.configurationDetail = config.getConfiguration('ProductsWtdDetail');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'DensityEstimation.page_title');
    this.loadProductsWeightedAverageValue();
  },
  methods: {
    loadProductsWeightedAverageValue(){
        let filters = [];
        
        filters.push({
            operator: '=',
            value: Utils.formatDateForAPI(this.filters.monthStartDate),
            property: 'MonthStartDate',
        });

        filters.push({
            operator: '=',
            value: true,
            property: 'IsFinal',
        });

        let body = {
            filter: JSON.stringify(filters)
        }
 
        this.optionCombo = [];
        this.filters.idPlanningTrueUpProductsWeightedAverageValue = null;

        CommonService.loadGeneric(this.configurationHeader.api, body, response => {
            if(response.success){
                this.productsWeightedAverageValue = response.data;
                this.optionCombo = response.data
            }
        });
    },
    loadSummary(){
        let filters = [];
        
        filters.push({
            operator: '=',
            value: Utils.formatDateForAPI(this.filters.monthStartDate),
            property: 'MonthStartDate',
        });

        filters.push({
            operator: '=',
            value: this.filters.idPlanningTrueUpProductsWeightedAverageValue,
            property: 'Id',
        })

        let body = {
            filter: JSON.stringify(filters)
        }

        this.weeklyData = {
            totalQuantity: null,
            weightedAverageDensity: null,
            weightedAveragePremiumOrDiscount: null
        };
        CommonService.loadGeneric(this.configurationHeader.api, body, response => {
            if(response.success){
                let item = response.data[0];
                this.weeklyData = {
                    totalQuantity: Utils.formatDecimal(item.totalQuantity, 3),
                    weightedAverageDensity: Utils.formatDecimal(item.weightedAverageDensity, 4),
                    weightedAveragePremiumOrDiscount: Utils.formatDecimal(item.weightedAveragePremiumOrDiscount, 3)
                };
            }
        });
    },
    loadProductsWtdDetail(){
        this.submitted = true;

        let filters = [];
        
        filters.push({
            operator: 'eq',
            value: this.filters.idPlanningTrueUpProductsWeightedAverageValue,
            property: 'IdPlanningTrueUpProductsWeightedAverageValue',
        })

        this.$refs.productsWtdDetail.filterFromView(filters);
        this.submitted = false;
        this.loadSummary();
    },

    // loadWeeklyData(){
    //     this.weeklyData = {
    //         totalQuantity: null,
    //         weightedAverageDensity: null,
    //         weightedAveragePremiumOrDiscount: null
    //     };
    //     for(let i = 0; i < this.productsWeightedAverageValue.length; i++){
    //         let item = this.productsWeightedAverageValue[i];

    //         if(item.id == this.filters.idPlanningTrueUpProductsWeightedAverageValue){
    //             this.weeklyData.totalQuantity = Utils.formatDecimal(item.totalQuantity, 3);
    //             this.weeklyData.weightedAverageDensity = Utils.formatDecimal(item.weightedAverageDensity, 4);
    //             this.weeklyData.weightedAveragePremiumOrDiscount = Utils.formatDecimal(item.weightedAveragePremiumOrDiscount, 3);
    //         }
    //     }
    // },
    onRowEdit(data){
        this.$store.dispatch("generic/setLoading", true);
        Service.updateProductWeightedAverageDetailValue(data, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
                this.loadProductsWtdDetail();
                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
            } else {
                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    },
    importFeedstocksWtdDetail(){
        this.$confirm.require({
        message: this.$t('messages.confirm_import'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {                  
          let body = {
            monthStartDate: Utils.formatDateForAPI(this.filtersImport.monthStartDate),
            endingInventoryDate: this.filtersImport.endingInventoryDate,
            poolName: this.filtersImport.poolName,
            isFinal: this.filtersImport.isFinal
          }

          this.$store.dispatch("generic/setLoading", true);
          Service.importProductsWeightedAverageDetailValue(body, 
            response => {   
              this.$store.dispatch("generic/setLoading", false);      
              if(response.success){
                this.showImportDialog = false;
                this.loadFeedstocksWtdDetail();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        reject: () => {
            this.$confirm.close();
        }
      });
    },
    exportExcel(){
        let body = {
            monthStartDate: Utils.formatDateForAPI(this.filters.monthStartDate),
            isFinal: true
        };

        this.$store.dispatch("generic/setLoading", true);
        let fileNameWithExtension = Utils.formatDateMonth(Utils.dateToCurrentTimeZone(this.filters.monthStartDate)) + " Density_Estimation.xlsx";
        Service.exportProductWeightedAverageValue(body, ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);
    
            if(success){
                var fileURL = window.URL.createObjectURL(new Blob([data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileNameWithExtension);
                document.body.appendChild(fileLink);
            
                fileLink.click();
            } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    }
  }
}

</script>

<template>
    <main>
        <Dialog v-model:visible="showImportDialog" modal class="col-2">
            <div class="field">
                <label for="monthStartDate">{{ $t('FeedstocksWeightedAverage.monthStartDate') }}</label>
                <Calendar 
                class="w-full" 
                v-model="this.filtersImport.monthStartDate" 
                name="monthStartDate" dateFormat="mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                view="month" 
                placeholder="mm/yy"/> 
            </div>

            <div class="field">
                <label for="endingInventoryDate">{{ $t('FeedstocksWeightedAverage.endingInventoryDate') }}</label>
                <Calendar 
                class="w-full" 
                v-model="this.filtersImport.endingInventoryDate" 
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                dateFormat="dd/mm/yy" 
                placeholder="dd/mm/yyyy"/> 
            </div>

            <div class="field">
                <label for="poolName">{{ $t('FeedstocksWeightedAverage.planningTrueUpFamilyPoolConfiguration') }}</label>
                <!--<InputText v-model="this.filtersImport.poolName" class="w-full" />-->
                <GenericCustomAutocompleteV2 
                    name="FamilyPoolConfigurationCombo"
                    v-model="this.filtersImport.poolName" 
                    class="w-full"
                    :format="{ label: 'label', value: 'value' }"
                    :api="`true-up/family-pool-configuration-combo?monthStartDate=${utils.formatDateForAPI(this.filtersImport.monthStartDate)}&isProduct=true`" />
                
            </div>

            <div class="isFinal">
                <label for="poolName">{{ $t('FeedstocksWeightedAverage.isFinal') }}</label>
                <GenericBooleanDropdown class="w-full" v-model="this.filtersImport.isFinal" style="margin-top: 2%;"/>
            </div>

            <template #footer>
                <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showImportDialog = false"/>
                <ResponsiveButton :label="$t('btn.import')" icon="pi pi-plus" class="p-button-text" @click="importFeedstocksWtdDetail()" />
            </template>

        </Dialog>

        <div class="m-5">
            <div class="grid">
                <div class="col-2">
                    <label for="dateFrom">{{$t('ProductsWeightedAverageValue.monthStartDate')}}</label>
                    <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.filters.monthStartDate"
                    name="monthStartDate" dateFormat="mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                    view="month" 
                    @data-select="loadProductsWeightedAverageValue" />
                </div>

                <div class="col-2">
                    <label for="familyPool">{{$t('ProductsWeightedAverageValue.planningTrueUpFamilyPoolConfiguration')}}</label>
                    <GenericCustomAutocompleteV2
                    class="p-inputtext-sm w-full"
                    v-model="filters.idPlanningTrueUpProductsWeightedAverageValue"
                    :staticOptions="optionCombo"
                    name="masterdata-product-combo" 
                    :format="{label: 'planningTrueUpFamilyPoolConfiguration', value: 'id' }" />
                </div>

                <div class="col-12 lg:col-4 m-2">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 p-button-sm p-button" @click="loadProductsWtdDetail()"/>
                    <ResponsiveButton :label="$t('btn.import')" icon="pi pi-download" class="mx-1 p-button-sm p-button-success mt-3" @click="showImportDialog = true"
                    v-if="!uiPermissions('ProductsWeightedAverageValueImportButton').isHidden"/>
                    <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="mx-1 p-button-sm p-button" @click="exportExcel()" />
                </div>

                <div class="col-8">
                    <GenericDataTable :configuration="configurationDetail" :category="'planning'" :name="'true-up-density-estimation'" 
                    ref="productsWtdDetail" :onDialogEditSave="onRowEdit" />
                </div>

                <div class="col-4 lg:col-3 m-5">
                    <Card>
                        <template #content>
                            <div class="grid formgrid" >
                                <div class="col-4 lg:col-6 field">
                                    <span>{{$t('ProductsWeightedAverageValue.totalQuantity')}}</span>
                                </div>
                                <div class="col-4 lg:col-3 field">
                                    <span>{{ this.weeklyData.totalQuantity }}</span>
                                </div>
                                <div class="col-4 lg:col-3 field">
                                    <span>{{ this.weeklyData.weightedAverageDensity }}</span>
                                </div>                                   
                            </div>
                            <div class="grid formgrid" >
                                <div class="col-4 lg:col-6 field">
                                    <span><b>{{$t('ProductsWeightedAverageValue.weightedAverageDensity')}}</b></span>
                                </div>
                                <div class="col-4 lg:col-3 field">
                                    <span>{{ this.weeklyData.totalQuantity }}</span>
                                </div>
                                <div class="col-4 lg:col-3 field yellow">
                                    <span>{{ this.weeklyData.weightedAverageDensity }}</span>
                                </div>                                   
                            </div>
                            <div class="grid formgrid" >
                                <div class="col-4 lg:col-6 field">
                                    <span><b>{{$t('ProductsWeightedAverageValue.weightedAveragePremiumOrDiscount')}}</b></span>
                                </div>
                                <div class="col-4 lg:col-3 field yellow">
                                    <span>{{ this.weeklyData.weightedAveragePremiumOrDiscount }}</span>
                                </div>                                 
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </main>
</template>

<style>
    .yellow{
        background-color: yellow;
        font-weight: bold;
    }
</style>